const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

export const RECALLS = createRequestTypes('RECALLS');
export const RECALL = createRequestTypes('RECALL');
export const DASHBOARD = createRequestTypes('DASHBOARD');

export const FACET_TOGGLE_COLLAPSE = 'FACET_TOGGLE_COLLAPSE';
export const FILTER_NODE_EXPAND = 'FILTER_NODE_EXPAND';
export const FILTER_NODE_COLLAPSE = 'FILTER_NODE_COLLAPSE';
export const FACET_SPOTLIGHT_CHANGE = 'FACET_SPOTLIGHT_CHANGE';

function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc
  }, {})
}



// WEBPACK FOOTER //
// ./src/actions/types.js